import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";

import ZPOTADDPAY from "../img/zoptaddpay.png";

import KKlogo from "../img/KK-zoo.png";
import CMlogo from "../img/CM-zoo.png";
import NMlogo from "../img/NM-zoo.png";
import UBlogo from "../img/UB-zoo.png";
import KNlogo from "../img/KN-zoo.png";
import SKlogo from "../img/SK-zoo.png";

import caroselkk from "../img/caroselkk.jpg";
import caroselcm from "../img/caroselcm.jpg";
import caroselnm from "../img/caroselnm.jpg";
import caroselub from "../img/caroselub.jpg";
import caroselkn from "../img/caroselkn.jpg";
import caroselsk from "../img/caroselsk.jpg";

import CManimal from "../img/00cm-animal.jpg";
import NManimal from "../img/00nm-animal.jpg";
import UBanimal from "../img/00ub-animal.jpg";
import KNanimal from "../img/00kn-animal.jpg";
import SKanimal from "../img/00sk-animal.jpg";

import kkcarosel from "../img/00kk-animal-moo.jpg";
import kkcarosel1 from "../img/00kk-animal-ele.jpg";
import kkcarosel2 from "../img/00kk-animal-moo2.jpg";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Outfit:wght@300;400;500;600&display=swap');


    @keyframes cookieSlideUp {
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }
  .zoo-home {
    background: #0a1628;
    color: #f1f5f9;
    overflow-x: hidden;
  }

  /* ===================== ANNOUNCEMENT MODAL ===================== */
  .zoo-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.85);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes float { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-12px); } }

  .zoo-modal-box {
    background: #0f172a;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 20px;
    overflow: hidden;
    max-width: 680px;
    width: 100%;
    box-shadow: 0 40px 100px rgba(0,0,0,0.7);
    animation: slideUp 0.35s ease;
  }

  .zoo-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }

  .zoo-modal-header h5 {
    font-size: 0.9rem;
    font-weight: 500;
    color: #94a3b8;
    margin: 0;
    letter-spacing: 0.03em;
  }

  .zoo-modal-close {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(255,255,255,0.06);
    border: none;
    color: #94a3b8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    transition: background 0.2s, color 0.2s;
  }

  .zoo-modal-close:hover { background: rgba(248,113,113,0.15); color: #f87171; }

  .zoo-modal-body img { width: 100%; display: block; }

  .zoo-modal-footer {
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid rgba(255,255,255,0.07);
  }

  .zoo-btn-secondary {
    padding: 9px 24px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    color: #94a3b8;
    font-size: 0.875rem;
    cursor: pointer;
    transition: background 0.2s;
  }
  .zoo-btn-secondary:hover { background: rgba(255,255,255,0.1); }

  /* ===================== HERO SECTION ===================== */
  .zoo-hero {
    position: relative;
    min-height: 92vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow: hidden;
  }

  .zoo-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, #0a1628 50%, transparent 100%);
    z-index: 1;
    pointer-events: none;
  }

  .zoo-hero-left {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 80px 60px 80px 80px;
    background: linear-gradient(135deg, #0a1628 0%, rgba(10,22,40,0.95) 100%);
  }

  .zoo-hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    background: rgba(34,197,94,0.1);
    border: 1px solid rgba(34,197,94,0.25);
    border-radius: 100px;
    font-size: 0.75rem;
    font-weight: 600;
    color: #22c55e;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 24px;
    width: fit-content;
  }

  .zoo-hero-badge::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #22c55e;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.4); }
  }

  .zoo-hero-logo {
    width: 200px;
    margin-bottom: 20px;
    filter: brightness(1.1);
  }

  .zoo-hero-title {
    font-size: clamp(2rem, 3.5vw, 3.2rem);
    font-weight: 900;
    line-height: 1.15;
    color: #f1f5f9;
    margin-bottom: 8px;
  }

  .zoo-hero-title span { color: #22c55e; }

  .zoo-hero-sub {
    font-size: 1rem;
    color: #64748b;
    margin-bottom: 40px;
    line-height: 1.6;
  }

  .zoo-hero-actions {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .zoo-btn-primary {
    padding: 14px 32px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 20px rgba(34,197,94,0.35);
    display: inline-block;
  }
  .zoo-btn-primary:hover {
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(34,197,94,0.5);
  }

  .zoo-btn-play {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    color: #94a3b8;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.2s;
  }
  .zoo-btn-play:hover { color: #f1f5f9; }

  .zoo-play-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    transition: background 0.2s;
  }
  .zoo-btn-play:hover .zoo-play-circle { background: rgba(34,197,94,0.15); border-color: rgba(34,197,94,0.4); }

  .zoo-hero-right {
    position: relative;
    overflow: hidden;
  }

  .zoo-hero-right .owl-carousel { height: 100%; }
  .zoo-hero-right .owl-stage-outer { height: 100%; }
  .zoo-hero-right .owl-stage { height: 100%; }
  .zoo-hero-right .owl-item { height: 100%; }

  .zoo-hero-right .carousel-head {
    height: 92vh;
    overflow: hidden;
  }

  .zoo-hero-right .carousel-head img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .zoo-hero-right::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #0a1628 0%, transparent 30%);
    pointer-events: none;
    z-index: 1;
  }

  /* Owl dots override */
  .zoo-hero .owl-dots {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }
  .zoo-hero .owl-dot span {
    background: rgba(255,255,255,0.3) !important;
    width: 8px !important;
    height: 8px !important;
  }
  .zoo-hero .owl-dot.active span { background: #22c55e !important; width: 24px !important; border-radius: 4px !important; }

  @media (max-width: 900px) {
    .zoo-hero { grid-template-columns: 1fr; min-height: auto; }
    .zoo-hero-left { padding: 60px 24px; }
    .zoo-hero-right .carousel-head { height: 50vw; min-height: 260px; }
    .zoo-hero::before { display: none; }
    .zoo-hero-right::after { background: linear-gradient(to bottom, #0a1628 0%, transparent 20%); }
  }

  /* ===================== SECTION LABEL ===================== */
  .zoo-section-label {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 8px;
  }

  .zoo-section-title {
    font-size: clamp(1.6rem, 3vw, 2.4rem);
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 0;
  }

  /* ===================== ZOO CARDS SECTION ===================== */
  .zoo-zoos-section {
    padding: 100px 0;
    position: relative;
  }

  .zoo-zoos-section::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(34,197,94,0.3), transparent);
  }

  .zoo-section-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
    margin-bottom: 64px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }

  .zoo-zoos-grid {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  /* ZOO CARD */
  .zoo-card {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 480px;
    overflow: hidden;
    border-radius: 20px;
    border: 1px solid rgba(255,255,255,0.06);
    background: rgba(15,23,42,0.6);
    margin-bottom: 32px;
    transition: border-color 0.3s;
  }

  .zoo-card:hover { border-color: rgba(34,197,94,0.2); }

  .zoo-card.reverse { direction: rtl; }
  .zoo-card.reverse > * { direction: ltr; }

  .zoo-card-image {
    position: relative;
    overflow: hidden;
  }

  .zoo-card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
    display: block;
  }

  .zoo-card:hover .zoo-card-image img { transform: scale(1.04); }

  .zoo-card-image-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(10,22,40,0.3) 0%, transparent 60%);
    pointer-events: none;
  }

  /* KK card uses carousel */
  .zoo-card-image .owl-carousel { height: 100%; }
  .zoo-card-image .owl-stage-outer,
  .zoo-card-image .owl-stage,
  .zoo-card-image .owl-item { height: 100%; }
  .zoo-card-image .carousel-content { height: 100%; }
  .zoo-card-image .carousel-content .item { height: 100%; }
  .zoo-card-image .carousel-content .item img { height: 100%; width: 100%; object-fit: cover; }

  .zoo-card-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 48px 52px;
  }

  .zoo-card-logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 20px;
    filter: drop-shadow(0 0 12px rgba(34,197,94,0.2));
  }

  .zoo-card-name {
    font-size: 1.8rem;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 20px;
  }

  .zoo-card-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 32px;
  }

  .zoo-card-info-row {
    display: flex;
    gap: 12px;
    font-size: 0.875rem;
    color: #64748b;
    align-items: flex-start;
  }

  .zoo-info-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: rgba(34,197,94,0.08);
    border: 1px solid rgba(34,197,94,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .zoo-card-info-row span { line-height: 1.5; color: #94a3b8; }

  .zoo-card-hours {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    background: rgba(34,197,94,0.08);
    border: 1px solid rgba(34,197,94,0.15);
    border-radius: 100px;
    font-size: 0.78rem;
    color: #22c55e;
    font-weight: 500;
    margin-bottom: 28px;
    width: fit-content;
  }

  .zoo-btn-ticket {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 13px 28px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 16px rgba(34,197,94,0.3);
    width: fit-content;
  }
  .zoo-btn-ticket:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(34,197,94,0.45); }

  @media (max-width: 860px) {
    .zoo-card, .zoo-card.reverse {
      grid-template-columns: 1fr;
      direction: ltr;
    }
    .zoo-card-image { min-height: 260px; }
    .zoo-card-body { padding: 32px 28px; }
    .zoo-zoos-grid, .zoo-section-header { padding: 0 20px; }
    .zoo-zoos-section { padding: 60px 0; }
  }
`;

const carouselOptions = {
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 4000,
  nav: false,
  dots: true,
  margin: 0,
}
// @keyframes cookieSlideUp {
//   from { transform: translateY(100%); opacity: 0; }
//   to   { transform: translateY(0);    opacity: 1; }
// };

const zoos = [
  {
    id: 'kk',
    logo: null, // KKlogo — passed in component
    name: 'สวนสัตว์เปิดเขาเขียว',
    address: '235 ม.7 ต.บางพระ อ.ศรีราชา จ.ชลบุรี 20110',
    phone: '038 318 444',
    hours: '08.00น. - 18.00น.',
    isCarousel: true,
  },
  {
    id: 'cm',
    name: 'สวนสัตว์เชียงใหม่',
    address: '100 ถ.ห้วยแก้ว ต.เชียงใหม่ อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50200',
    phone: '053 221 179',
    hours: '08.00น. - 17.00น.',
  },
  {
    id: 'kn',
    name: 'สวนสัตว์ขอนแก่น',
    address: '88 ม.8 ต.คำม่วง อ.เขาสวนกวาง จ.ขอนแก่น 40280',
    phone: '086 459 4192',
    hours: '08.00น. - 16.30น.',
    reverse: true,
  },
  {
    id: 'nm',
    name: 'สวนสัตว์นครราชสีมา',
    address: '111 ม.1 ต.ไชยมงคล อ.เมืองนครราชสีมา จ.นครราชสีมา 30000',
    phone: '083 372 0404',
    hours: '08.00น. - 17.00น.',
  },
  {
    id: 'ub',
    name: 'สวนสัตว์อุบลราชธานี',
    address: '112 ม.17 ต.ขามใหญ่ อ.เมืองอุบลราชธานี จ.อุบลราชธานี 34000',
    phone: '045 252 761',
    hours: '08.00น. - 16.30น.',
    reverse: true,
  },
  {
    id: 'sk',
    name: 'สวนสัตว์สงขลา',
    address: '189 ม.5 ถ.สงขลา-นาทวี ต.เขารูปช้าง อ.เมืองสงขลา จ.สงขลา 90000',
    phone: '074 598 555',
    hours: '08.00น. - 16.30น.',
  },
];

function ZooCard({ zoo, onBuyTicket, logos, images }) {
  const logo = logos[zoo.id];
  const image = images[zoo.id];

  const InfoRow = ({ icon, text }) => (
    <div className="zoo-card-info-row">
      <div className="zoo-info-icon">{icon}</div>
      <span>{text}</span>
    </div>
  );

  const imageSection = (
    <div className="zoo-card-image">
      {zoo.isCarousel ? (
        <OwlCarousel className="owl-theme" {...carouselOptions}>
          {[kkcarosel, kkcarosel1, kkcarosel2].map((src, i) => (
            <div className="carousel-content" key={i}>
              <div className="item"><img src={src} alt="zoo" /></div>
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <>
          <img src={image} alt={zoo.name} />
          <div className="zoo-card-image-overlay" />
        </>
      )}
    </div>
  );

  const bodySection = (
    <div className="zoo-card-body">
      {logo && <img src={logo} alt={zoo.name} className="zoo-card-logo" />}
      <h3 className="zoo-card-name">{zoo.name}</h3>
      <div className="zoo-card-info">
        <InfoRow icon="📍" text={`ที่อยู่: ${zoo.address}`} />
        <InfoRow icon="📞" text={`โทร: ${zoo.phone}`} />
      </div>
      <div className="zoo-card-hours">
        🕗 เปิดทุกวัน {zoo.hours}
      </div>
      <button className="zoo-btn-ticket" onClick={onBuyTicket}>
        🎫 ซื้อตั๋ว
      </button>
    </div>
  );

  return (
    <div className={`zoo-card${zoo.reverse ? ' reverse' : ''}`}>
      {zoo.reverse ? <>{bodySection}{imageSection}</> : <>{imageSection}{bodySection}</>}
    </div>
  );
}

function Home() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [announceImage, setAnnounceImage] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [showCookie, setShowCookie] = useState(() => !localStorage.getItem("cookie_accepted"));

  const acceptCookie = () => {
    localStorage.setItem("cookie_accepted", "true");
    setShowCookie(false);
  };
  const declineCookie = () => setShowCookie(false);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, []);

  useEffect(() => {
    fetch("https://www.addpay.co.th/service-ui/service-my-zoo-admin/announce.php", { method: "GET", redirect: "follow" })
      .then(r => r.json())
      .then(result => {
        if (result.status === true) {
          setAnnounceImage(result.data.image);
          const hideDate = new Date(result.data.announce_date);
          if (new Date() > hideDate) setShowModal(false);
        } else {
          setShowModal(false);
        }
      })
      .catch(() => setShowModal(false));
  }, []);

  const handleBuyTicket = () => {
    navigate(token ? "/addticket" : "/login");
  };

  const logos = { kk: KKlogo, cm: CMlogo, nm: NMlogo, ub: UBlogo, kn: KNlogo, sk: SKlogo };
  const images = { cm: CManimal, nm: NManimal, ub: UBanimal, kn: KNanimal, sk: SKanimal };

  return (
    <div className="zoo-home">
      <style>{styles}</style>
      <Navbar />

      {/* ANNOUNCEMENT MODAL */}
      {showModal && announceImage && (
        <div className="zoo-modal-overlay">
          <div className="zoo-modal-box">
            <div className="zoo-modal-header">
              <h5>ประชาสัมพันธ์ องค์การสวนสัตว์แห่งประเทศไทย</h5>
              <button className="zoo-modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="zoo-modal-body">
              <img src={announceImage} alt="ประชาสัมพันธ์" />
            </div>
            <div className="zoo-modal-footer">
              <button className="zoo-btn-secondary" onClick={() => setShowModal(false)}>ปิด</button>
            </div>
          </div>
        </div>
      )}

      {/* HERO */}
      <section className="zoo-hero">
        <div className="zoo-hero-left">
          <div className="zoo-hero-badge">Zoo e-Ticket</div>
          <img src={ZPOTADDPAY} alt="ZPOT ADDPAY" className="zoo-hero-logo" />
          <h1 className="zoo-hero-title">
            องค์การสวนสัตว์<br />
            <span>แห่งประเทศไทย</span>
          </h1>
          <p className="zoo-hero-sub">ในพระบรมราชูปถัมภ์ · ซื้อตั๋วออนไลน์ได้ทุกที่ทุกเวลา</p>
          <div className="zoo-hero-actions">
            <Link to="/Thaizoorealmaps" className="zoo-btn-primary">แผนที่นำเที่ยว</Link>
            <Link to="/VDOLive" className="zoo-btn-play">
              <div className="zoo-play-circle">▶</div>
              <span>Zoo Streaming</span>
            </Link>
          </div>
        </div>

        <div className="zoo-hero-right">
          <OwlCarousel className="owl-theme" {...carouselOptions}>
            {[caroselkk, caroselcm, caroselkn, caroselnm, caroselub, caroselsk].map((src, i) => (
              <div className="carousel-head" key={i}>
                <img src={src} alt="zoo" />
              </div>
            ))}
          </OwlCarousel>
        </div>
      </section>

      {/* ZOO LIST */}
      <section className="zoo-zoos-section">
        <div className="zoo-section-header">
          <div>
            <div className="zoo-section-label">องค์การสวนสัตว์
แห่งประเทศไทย</div>
            <h2 className="zoo-section-title">เลือกสวนสัตว์ที่ต้องการ</h2>
          </div>
          <button className="zoo-btn-ticket" onClick={handleBuyTicket} style={{ marginBottom: 4 }}>
            🎫 ซื้อตั๋วทั้งหมด
          </button>
        </div>

        <div className="zoo-zoos-grid">
          {zoos.map(zoo => (
            <ZooCard
              key={zoo.id}
              zoo={zoo}
              onBuyTicket={handleBuyTicket}
              logos={logos}
              images={images}
            />
          ))}
        </div>
      </section>


      {/* COOKIE CONSENT BANNER */}
      {showCookie && (
        <div style={{
          position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
          animation: "cookieSlideUp .45s cubic-bezier(.22,1,.36,1)",
        }}>
          <div style={{
            background: "linear-gradient(to top, rgba(0,0,0,.88), rgba(15,23,20,.94))",
            backdropFilter: "blur(20px)",
            borderTop: "1px solid rgba(74,222,128,.2)",
            boxShadow: "0 -8px 40px rgba(0,0,0,.4)",
            padding: "18px clamp(16px,5vw,48px)",
          }}>
            <div style={{
              maxWidth: 1100, margin: "0 auto",
              display: "flex", alignItems: "center",
              gap: "clamp(12px,3vw,28px)", flexWrap: "wrap",
            }}>
              <div style={{
                width: 46, height: 46, borderRadius: 13, flexShrink: 0,
                background: "linear-gradient(135deg,#166534,#16a34a)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 22, boxShadow: "0 4px 14px rgba(22,163,74,.35)",
              }}>🍪</div>

              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{
                  fontSize: "clamp(13px,2vw,15px)", fontWeight: 700,
                  color: "#fff", marginBottom: 3,
                }}>เว็บไซต์นี้ใช้คุกกี้</div>
                <div style={{ fontSize: "clamp(11px,1.6vw,13px)", color: "rgba(255,255,255,.5)", lineHeight: 1.6 }}>
                  เราใช้คุกกี้เพื่อพัฒนาประสบการณ์การใช้งาน วิเคราะห์การเข้าชม และแสดงเนื้อหาที่เหมาะสมกับคุณ
                </div>
              </div>

              <div style={{ display: "flex", gap: 10, flexShrink: 0, flexWrap: "wrap" }}>
                <button onClick={declineCookie} style={{
                  padding: "9px 20px", borderRadius: 10,
                  border: "1px solid rgba(255,255,255,.15)",
                  background: "rgba(255,255,255,.06)",
                  color: "rgba(255,255,255,.6)",
                  fontSize: 13, fontWeight: 600, cursor: "pointer",
                }}>ปฏิเสธ</button>

                <button onClick={acceptCookie} style={{
                  padding: "9px 24px", borderRadius: 10, border: "none",
                  background: "linear-gradient(135deg,#16a34a,#22c55e)",
                  color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer",
                  boxShadow: "0 4px 14px rgba(22,163,74,.4)",
                }}>✓ ยอมรับทั้งหมด</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Home;